export const COMPONENT_SELECTOR_SEPARATOR = ';';
export const ROUTER_PARAMETER_PREFIX = ':';
